(ns practitest.frontend.components2.dndkit
  (:require
    ["@dnd-kit/core" :as dnd-core]
    ["@dnd-kit/sortable" :as dnd-sortable]
    [reagent.core :as reagent]))

;; Simple wrapper for CLJS-friendly dndkit wrapping

(def dnd-context (reagent/adapt-react-class dnd-core/DndContext))
(def sortable-context (reagent/adapt-react-class dnd-sortable/SortableContext))
(def drag-overlay (reagent/adapt-react-class dnd-core/DragOverlay))

(defn- to-cljs-map
  [m]
  (js->clj m :keywordize-keys true))

(defn use-sortable [id {:keys []}]
  (to-cljs-map (dnd-sortable/useSortable #js {:id id})))

(defn use-draggable [id {:keys []}]
  (to-cljs-map (dnd-core/useDraggable #js {:id id})))

(defn- round-or-zero [n]
  (if (nil? n)
    0
    (js/Math.round n)))

(defn build-transform-string
  [{:keys [x y] :as transform}]
  (when transform
    (str "translate3d(" (round-or-zero x) "px," (round-or-zero y) "px, 0)")))

;; kebab case ?
(def verticalListSortingStrategy dnd-sortable/verticalListSortingStrategy)
(def horizontalListSortingStrategy dnd-sortable/horizontalListSortingStrategy)
(def array-move dnd-sortable/arrayMove)

